module.exports = __webpack_public_path__ + "img/LTE.b935906a.svg";